import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import SamlCallback from './pages/SamlCallback';
import CognitoCallback from './pages/CognitoCallback';
import OidcCallback from './pages/OidcCallback';
import SyberKeyMFA from './pages/SyberKeyMFA';
import { AuthProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/syberkey-mfa" element={<SyberKeyMFA />} />
            <Route path="/saml/acs" element={<SamlCallback />} />
            <Route path="/saml/callback" element={<SamlCallback />} />
            <Route path="/callback" element={<CognitoCallback />} />
            <Route path="/login/callback" element={<CognitoCallback />} />
            <Route path="/oidc/callback" element={<OidcCallback />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
